export const imagePickerClassName = 'image-picker';
